export const LEAVE_POLLS = `
  query leavePolls($tenant_id: Int!, $filter: FilterLeavePollInput) {
    leavePolls(tenant_id: $tenant_id, filter: $filter) {
      __typename
      ... on LeavePoll {
        id
        name
        active
        welcome_message
        thank_you_message
        questions {
          id
          poll_id
          position
          question
          answer_type
          required
          visible_to_chair
          choices {
            id
            question_id
            label
            position
          }
        }
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const LEAVE_FORMS = `
  query leaveForms($tenant_id: Int!, $filter: FilterLeaveFormInput) {
    leaveForms(tenant_id: $tenant_id, filter: $filter) {
      __typename
      ... on LeaveForm {
        id
        contact_id
        group_movement_id
        poll_id
        status_id
        responsible_id
        token
        submitted_at
        interviewer_comment
        its
        uts
        poll {
          id
          name
          welcome_message
          thank_you_message
          questions {
            id
            poll_id
            position
            question
            answer_type
            required
            visible_to_chair
            choices {
              id
              question_id
              label
              position
            }
          }
        }
        status {
          id
          name
          position
        }
        answers {
          id
          form_id
          question_id
          text
          choice_ids
        }
        call_attempts {
          id
          leave_form_id
          attempt_number
          status
          call_date
          comment
        }
        group_movement {
          id
          group_id
          request_id
          request_reason_id
          applied_from
          data
          group {
            id
            name
            program {
              id
              name
            }
            program_variant {
              id
              name
            }
            group_chair {
              id
              date_from
              date_to
              chair {
                id
                contact {
                  id
                  firstname
                  lastname
                }
              }
            }
          }
          member {
            id
            start_date
            contact {
              id
              firstname
              lastname
            }
          }
          request {
            id
            description
          }
        }
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;
